import React from "react"

import PropTypes from "prop-types"

import "./SkeletonLoader.scss"

const SkeletonLoader = ({ width, height = 346 }) => {
  return (
    <div className="skeleton-loader" style={{ height, width }}>
      <div className="skeleton-loader__gradient" />
    </div>
  )
}

SkeletonLoader.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
}

export default SkeletonLoader
